import type { ReactNode } from 'react'

export type DialogBusType = 'warning' | 'error' | 'info'

export type DialogBusProps = {
  title: string
  content: ReactNode
  type?: DialogBusType
  onClose?: () => void
}

const dialogBus = new EventTarget()

export function emitDialog(props: DialogBusProps) {
  dialogBus.dispatchEvent(new CustomEvent<DialogBusProps>('dialogInfo', { detail: props }))
}

export function subscribeEmitDialog(handler: (props: DialogBusProps) => void): () => void {
  const listener = (event: Event) => {
    const props = event as CustomEvent<DialogBusProps>
    handler(props.detail)
  }
  dialogBus.addEventListener('dialogInfo', listener)

  return () => dialogBus.removeEventListener('dialogInfo', listener)
}
